<template>
  <div id="front-end" class="img-container">
    <img src="@/assets/intro/front-end/template.png" class="template" alt="">
    <img src="@/assets/intro/front-end/cursor.png" class="cursor" alt="">
    <img src="@/assets/intro/front-end/tailwind.png" class="tailwind" alt="">
    <img src="@/assets/intro/front-end/code.png" class="code" alt="">
    <img src="@/assets/intro/front-end/es-lint.png" class="es-lint" alt="">
    <img src="@/assets/intro/front-end/vue.png" class="vue" alt="">
    <img src="@/assets/intro/front-end/import.png" class="import" alt="">
    <img src="@/assets/intro/front-end/btn.png" class="btn-tag" alt="">
    <img src="@/assets/intro/front-end/methods.png" class="methods" alt="">
    <img src="@/assets/intro/front-end/lns-button.png" class="lns-button" alt="">
    <img src="@/assets/intro/front-end/gambi.png" class="gambi" alt="">
    <img src="@/assets/intro/front-end/todo.png" class="todo" alt="">
    <img src="@/assets/intro/front-end/react.png" class="react" alt="">
  </div>
</template>
<script>
import backgroundAnimation from './background-animation'
export default {
  name: 'FrontEndBackground',
  mixins: [backgroundAnimation],
  mounted () {
    this.backgroundAnimation(
      'front-end',
      0.05,
      0.8,
      'display-front-end-background'
    )
  }
}
</script>
<style scoped lang="sass">
  @tailwind utilities

  .img-container
    @apply absolute half-t -translate-y-50 w-screen
    height: 14rem
    left: $mobile-background-transition-distance
    & > *
      @apply absolute
    @screen sm-l
      height: 11rem
    @screen md
      height: 13rem

  .template
    @apply hidden
    @screen lg
      @apply block
      width: 25rem
      left: 0%
      top: calc(100% + 3rem)
    @include cs(1000)
      width: 28rem
      left: 5%
    @include cs(1100)
      left: 10%
    @screen xl
      width: 30rem
      left: -2%
    @screen xxl
      top: initial
      left: -5%
      bottom: 0

  .cursor
    @apply hidden
    @include csh-lg(1000)
      @apply block
      width: 40rem
      bottom: calc(100% + 4rem)
      left: 2%
    @screen xl
      @apply block
      width: 44rem
      bottom: calc(100% + 14rem)
      left: 4%
    @screen xxl
      bottom: initial
      top: calc(100% + 4rem)
      left: 1%

  .tailwind
    width: 8rem
    top: -9.5rem
    left: 1rem
    @screen sm-l
      top: initial
      bottom: 1rem
    @screen md
      top: initial
      bottom: calc(100% + 5rem)
      width: 12rem
      left: 18%
    @screen lg
      width: 10rem
      left: 26%
      bottom: calc(100% + 6rem)
    @include csh-lg(1000)
      left: initial
      right: 2%
      bottom: calc(100% + 22rem)
    @screen xl
      right: initial
      left: 15%
    @screen xxl
      bottom: initial
      top: calc(100% + 10rem)
      left: 25%

  .code
    @apply hidden
    @screen md
      @apply block
      width: 9rem
      left: -2rem
      top: 2rem
    @screen lg
      @apply half-t -translate-y-50
      left: 2rem
    @screen xl
      left: -5vw
    @screen xxl
      @apply hidden
    @screen xxxl
      @apply block
      left: 25%

  .es-lint
    @apply hidden
    @screen lg
      @apply block
      left: 5%
      width: 28rem
      bottom: calc(100% + 16rem)
    @include csh-lg(1000)
      @apply hidden
    @screen xl
      @apply block
      width: 32rem
      left: 35%
      bottom: calc(100% + 8rem)
    @screen xxl
      @apply hidden
    @screen xxxl
      @apply block
      bottom: calc(100% + 14rem)
      left: 20%

  .vue
    width: 6rem
    top: -16rem
    left: 2rem
    @screen sm-l
      top: -8rem
      width: 7rem
    @screen md
      top: initial
      bottom: calc(100% + 14rem)
      width: 10rem
    @screen lg
      width: 8rem
      bottom: calc(100% + 5rem)
      left: 4rem
    @include csh-lg(1000)
      left: initial
      right: 20%
      bottom: calc(100% + 22rem)
    @screen xl
      left: 0
    @screen xxl
      right: initial
      left: 10%
      bottom: -3rem
    @screen xxxl
      left: 23%
      bottom: calc(100% + 2rem)
      width: 9rem

  .import
    @apply hidden
    @screen sm-l
      @apply block
      width: 30rem
      top: calc(100% + 2rem)
    @screen lg
      @apply block
      width: 30rem
      top: calc(100% + 3rem)
      right: 0%
    @include cs(1000)
      width: 32rem
    @include cs(1100)
      right: 2%
    @screen xl
      width: 33rem
      right: 15%
    @screen xxl
      top: initial
      bottom: calc(100% + 3rem)
      right: 20%
    @include csh-xxl(1000)
      @apply -translate-x-50
      left: 55%
      right: initial
      bottom: calc(100% + 5rem)
    @screen xxxl
      bottom: calc(100% + 8rem)
      left: 56%
      width: 35rem

  .btn-tag
    width: 80vw
    left: 50%
    top: -16rem
    @screen sm-l
      width: 20rem
      top: calc(100% + 1rem)
      left: 75%
    @screen md
      width: 25rem
      top: initial
      bottom: calc(100% + 4rem)
    @screen lg
      left: 60%
      width: 23rem
      bottom: calc(100% + 6rem)
    @screen xl
      width: 22rem
      top: calc(100% + 3rem)
      left: 93%
    @include csh-xl(1200)
      width: 27rem
      left: initial
      right: 15%
      top: calc(100% + 22rem)
    @screen xxl
      top: initial
      left: initial
      right: -11%
      bottom: calc(100% + 9rem)
      width: 25rem
    @screen xxxl
      width: 27rem
      bottom: calc(100% + 8rem)

  .methods
    @apply hidden
    @screen md
      @apply block
      width: 30rem
      top: 120%
      left: 75%
    @screen lg
      @apply hidden
    @screen xl
      @apply block
      width: 33rem
      top: initial
      bottom: calc(100% + 2rem)
      left: 80%
    @screen xxl
      bottom: -2rem
      width: 30rem
      left: 85%
    @screen xxxl
      bottom: -3rem
      left: 87%

  .lns-button
    min-width: 114vw
    left: 5%
    top: 110%
    @screen sm-l
      @apply hidden
    @screen md
      min-width: initial
      width: 40rem
      top: 120%
      left: -15%
    @screen lg
      top: calc(100% + 19rem)
      width: 33rem
      left: initial
      right: -8%
    @include cs(1000)
      right: -5%
    @screen xl
      @apply hidden
    @include csh-xl(1000)
      @apply block
      width: 38rem
      top: calc(100% + 20rem)
      left: 43%
    @screen xxl
      @apply block
      width: 39rem
      top: calc(100% + 4rem)
      left: 56%
    @screen xxxl
      width: 41rem

  .gambi
    @apply hidden
    @screen xl
      @apply block
      width: 8rem
      bottom: calc(100% + 32rem)
      left: 88%
    @screen xxl
      @apply half-l -translate-x-50
      bottom: calc(100% + 26rem)
    @screen xxxl
      transform: none
      bottom: initial
      top: calc(100% + 22rem)
      left: initial
      right: 1%

  .todo
    @apply half-l -translate-x-50
    bottom: 100%
    width: 90%
    @screen sm-l
      width: 60%
      bottom: calc(100% + 1rem)
    @screen md
      width: 60%
    @screen lg
      width: 50%
    @screen xxl
      transform: none
      left: 46%
      width: 30rem
      top: 2rem
      bottom: initial

  .react
    width: 36vw
    right: -10%
    top: 0
    @screen sm-l
      width: 10rem
      right: -3%
    @screen md
      width: 11rem
      right: -2rem
      top: 3rem
    @screen lg
      right: 3%
    @screen xl
      /*width: 10rem*/
    @screen xxl
      width: 10rem
      top: 6rem
      right: 17%
    @screen xxxl
      width: 12rem
      top: 5rem
</style>
